module.exports = __webpack_public_path__ + "img/register-wait.888ab7a5.png";